import {
  ChangeDetectorRef,
  Component,
  ContentChild,
  forwardRef,
  Input,
  OnInit,
  TemplateRef,
  ViewChild
} from "@angular/core";
import {AbstractVisbosControl} from "../abstract-visbos-control";
import {FormBuilder, FormControl} from "@angular/forms";
import {IModel} from "../../../../../shared/view-model/imodel.interface";
import {AutoComplete} from "primeng/components/autocomplete/autocomplete";
import {appInjector} from "../../../../../index";


@Component({
  selector: 'vb-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => AutocompleteComponent)}]
})
export class AutocompleteComponent<T extends IModel> extends AbstractVisbosControl<T, FormControl> implements OnInit {

  @ViewChild('inputField')
  inputField: AutoComplete;

  @Input()
  searchFunction: (searchString: string, itemList: T[]) => T[];

  @ContentChild(TemplateRef) vbTemplate: TemplateRef<any>;

  private _items: T[];

  @Input()
  placeholder: string = "Tippen für Autovervollständigung...";

  @Input()
  dropdown: boolean = false;

  @Input()
  set items(items: T[]) {
    this._items = items;

    if (items) {
      this.itemList = JSON.parse(JSON.stringify(items));
    } else {
      this.itemList = [];
    }

    this.removeItemOnListChange();
  }

  get items(): T[] {
    return this._items;
  }

  @Input()
  itemList: T[] = [];

  private _loading: boolean = false;


  @Input()
  set loading(value: boolean) {
    this._loading = value;
  }

  get loading(): boolean {
    return this._loading;
  }

  suggestions: T[] = [];

  constructor(fb: FormBuilder, cd: ChangeDetectorRef) {
    super(fb, cd, null)
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected onItemChanges(item: T) {
    if (item) {
      this.onSelect(item);
      this.cd.detectChanges();
    }
  }


  removeItemOnListChange() {

    if (!this.itemList || !this.item) {
      return;
    }

    if (!this.itemList.find(i => i.cuid == this.item.cuid)) {
      this.item = null;
      this.control.reset();
    }
  }

  onSelect(selectedItem: T) {
    this.control.setValue(selectedItem.cuid);
  }

  buildControlContent(): FormControl {
    return AutocompleteComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormControl {
    fb = fb ? fb : appInjector().get(FormBuilder);
    return fb.control(null);
  }

  search(event) {

    if (!this.itemList) {
      return;
    }

    this.control.reset();

    if (this.searchFunction) {
      this.suggestions = this.searchFunction(event.query, this.itemList);
    } else {
      this.suggestions = this.itemList
        .filter(((i: T) => {
          let l = i.label.toLowerCase();
          return l.includes(event.query.toLowerCase());
        }));
    }

  }

  focus() {
    this.inputField.el.nativeElement.children[0].children[0].focus();
  }

  handleDropdown(event) {
    this.suggestions = [];
    this.suggestions = this.itemList;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/forms/autocomplete/autocomplete.component.ts